import { render, staticRenderFns } from "./InformButton.vue?vue&type=template&id=230b08bd&scoped=true&"
import script from "./InformButton.vue?vue&type=script&lang=js&"
export * from "./InformButton.vue?vue&type=script&lang=js&"
import style0 from "./InformButton.vue?vue&type=style&index=0&id=230b08bd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230b08bd",
  null
  
)

export default component.exports